import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { Icon } from "../index.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
export const iconSizes = {
    small: 16,
    large: 24,
};
export const StyledOfferTag = styled.div.withConfig({ displayName: "auir-611444a-StyledOfferTag", componentId: "auir-611444a-1inhusf" }) `
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(
    ${(props) => props.size === 'small'
    ? props.theme.responsive.spacing.xs
    : props.theme.responsive.spacing.s}
  );
`;
export const StyledTextContainer = styled.span.withConfig({ displayName: "auir-611444a-StyledTextContainer", componentId: "auir-611444a-gorpzp" }) `
  background-color: var(${(props) => props.theme.colors.ui.highlight.tertiary});
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(
    ${(props) => props.size === 'small'
    ? props.theme.responsive.spacing.xs
    : props.theme.responsive.spacing.s}
  );

  ${(props) => injectSpacing('padding')({
    theme: props.theme,
    outerSpacing: props.size === 'small'
        ? ['xxs', 'xs', 'xxs', 'xs']
        : ['xxs', 's', 'xxs', 's'],
})}

  padding-top: 2px;
  padding-bottom: 2px;
`;
export const StyledLabel = styled.span.withConfig({ displayName: "auir-611444a-StyledLabel", componentId: "auir-611444a-cnevoc" }) `
  color: var(${(props) => props.theme.colors.ui.secondary});

  ${(props) => injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1')}
`;
export const StyledButton = styled.button.withConfig({ displayName: "auir-611444a-StyledButton", componentId: "auir-611444a-1apf0d6" }) `
  color: var(${(props) => props.theme.colors.interaction.primary.default});
  cursor: pointer;
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
`;
export const StyledOfferTagIcon = styled(Icon).withConfig({ displayName: "auir-611444a-StyledOfferTagIcon", componentId: "auir-611444a-1e5rtc5" }) `
  flex-shrink: 0;
  &:hover {
    color: var(${(props) => props.theme.colors.interaction.primary.hover});
  }
  &:active {
    color: var(${(props) => props.theme.colors.interaction.primary.active});
  }
`;
export const StyledIcon = styled.svg.withConfig({ displayName: "auir-611444a-StyledIcon", componentId: "auir-611444a-patnwa" }) `
  display: block;
  color: var(${(props) => props.theme.colors.ui.secondary});
  flex-shrink: 0;
`;
//# sourceMappingURL=OfferTag.styles.mjs.mjs.map